"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var PartnersBalancesListCtl = /** @class */ (function (_super) {
    __extends(PartnersBalancesListCtl, _super);
    function PartnersBalancesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.balance; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    PartnersBalancesListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    PartnersBalancesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "partner balance with id [" + id + "] not found !";
    };
    PartnersBalancesListCtl.prototype.LoadData = function (partnerId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPartnerBalancesByPartnerIdGet.exec({ user_partner_id: partnerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    balance: resp.list[i].balance,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PartnersBalancesListCtl;
}(BaseController_1.BaseController));
exports.PartnersBalancesListCtl = PartnersBalancesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ctl/PartnersBalancesListCtl.ts
// module id = 996
// module chunks = 0